import { Link, useMatch } from "react-router-dom";
import React, { useState, useContext, useEffect } from "react";
import { GlobalContext } from "../context/Provider";
import henceforthApi from "../utils/henceforthApi";

const ContentProvider=(props)=>{
    const { authState, authDispatch } = useContext(GlobalContext);
    const [state, setState] = useState([]);
    henceforthApi.setToken(authState?.access_token);
    const initialiseData = async () => {
      try {
        let apiRes = await henceforthApi.Policies.all(props.type);
       setState(  Array.isArray(apiRes) ? apiRes[0] : "")
      } catch (error) { }
    };
    useEffect(() => {
      initialiseData();
    }, []);
return(
  <div className={`create-auction visible privacy-policy-page`}>
  <div className="container-fluid px-4">
    <div className="d-flex justify-content-between align-items-center py-4">
      <Link to={`/`}>
        {/* <img src={Logo} className="img-fluid" /> */}
      </Link>
      {/* <button className="btn btn-danger py-0 px-2">
        <i className="fa-solid fa-xmark" onClick={()=>window.history.back()}></i></button> */}
    </div>
    <div className="create-aution-card pages">
      <div className="page-header">
        <h3 className="text-center fw-bold mb-0">
          { state.type ? state.type.split("_").join(" ") : ""}
          </h3>
      </div>
      <div dangerouslySetInnerHTML={{ __html: state.description ? state.description :"trt" }} className='terms-of-service-box'>
      </div>
    </div>
  </div>
</div >
)
}
export default ContentProvider